import UserPhotoGridCertification from './UserPhotoGridCertification';
import UserPhotoGridPictures from './UserPhotoGridPictures';
import Grid from '../Grid';
import { TProps } from '.';

const UserPhotoGrid = ({
	onClickDeletePictureBtn,
	onClickAcceptDenyBtn,
	cardClassName,
	className,
	userData,
	withButtons = true,
	readonly = false
}: TProps) => (
	<Grid className={`gap-4 items-baseline ${className}`}>
		<UserPhotoGridCertification
			cardClassName={cardClassName}
			withButtons={withButtons}
			userData={userData} />
		<UserPhotoGridPictures 
			onClickDeletePictureBtn={onClickDeletePictureBtn}
			onClickAcceptDenyBtn={onClickAcceptDenyBtn}
			cardClassName={cardClassName}
			withButtons={withButtons}
			readonly={readonly}
			userData={userData} />
	</Grid>
);

export default UserPhotoGrid;
